function ariaFromAttr() {
	return {
		restrict: "A",
		link: function(scope, element, attrs) {
			const targetAttribute = element[0].getAttribute(attrs.ariaFromAttr);
			element[0].setAttribute("aria-label", targetAttribute);
		}
	};
}
export default angular
	.module("vesl.behaviors.aria-from-attr", [])
	.directive("ariaFromAttr", ariaFromAttr).name;
